import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAdminAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const adminStatus = localStorage.getItem('admin_logged_in');
    if (adminStatus !== 'true') {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  const isAdminLoggedIn = () => {
    return localStorage.getItem('admin_logged_in') === 'true';
  };

  const adminLogout = () => {
    localStorage.removeItem('admin_logged_in');
    navigate('/', { replace: true });
  };

  return { isAdminLoggedIn, adminLogout };
}; 